var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-header text-center bg-primary"
  }, [_c('h3', [_vm._v("Create New Premium AX")])]), _c('div', {
    staticClass: "card-body"
  }, [_c('h5', [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.PremiumAxPath.name
      }
    }
  }, [_c('span', {
    staticClass: "badge badge-primary"
  }, [_c('i', {
    staticClass: "fa fa-rotate-left mr-1"
  }), _vm._v("Back")])])], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "organization"
    }
  }, [_vm._v("Item Name"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" :")]), _c('multiselect', {
    attrs: {
      "label": "name",
      "track-by": "name",
      "placeholder": "type to find item...",
      "open-direction": "bottom",
      "options": _vm.items,
      "searchable": true,
      "loading": _vm.isLoadingItemSearch,
      "close-on-select": true
    },
    on: {
      "search-change": _vm.findItemName
    },
    model: {
      value: _vm.itemId,
      callback: function ($$v) {
        _vm.itemId = $$v;
      },
      expression: "itemId"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(" Oops! No elements found. Consider changing the search query. ")])]), _c('small', {
    staticClass: "font-weight-bold"
  }, [_vm._v("ITEM ID : " + _vm._s(this.itemid_label))])], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "organization"
    }
  }, [_vm._v("Name"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" :")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.name,
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "EBOOK:Filosofi Teras"
    },
    domProps: {
      "value": _vm.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "organization"
    }
  }, [_vm._v("Base Price"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" :")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.basePrice,
      expression: "basePrice"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "49000"
    },
    domProps: {
      "value": _vm.basePrice
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.basePrice = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "organization"
    }
  }, [_vm._v("Premium ID AX"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" :")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.premium_idax,
      expression: "premium_idax"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "528196376"
    },
    domProps: {
      "value": _vm.premium_idax
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.premium_idax = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "organization"
    }
  }, [_vm._v("Vendor"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" :")]), _c('multiselect', {
    attrs: {
      "label": "name",
      "track-by": "name",
      "placeholder": "type to find vendor...",
      "open-direction": "bottom",
      "options": _vm.items_vendor,
      "searchable": true,
      "loading": _vm.isLoadingSearch,
      "close-on-select": true
    },
    on: {
      "search-change": _vm.findVendorName,
      "input": _vm.getVendorAx
    },
    model: {
      value: _vm.vendor,
      callback: function ($$v) {
        _vm.vendor = $$v;
      },
      expression: "vendor"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(" Oops! No elements found. Consider changing the search query. ")])])], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Vendor ID AX : ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.vendor_id_ax,
      expression: "vendor_id_ax"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "V-000005276"
    },
    domProps: {
      "value": _vm.vendor_id_ax
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.vendor_id_ax = $event.target.value;
      }
    }
  })]), _c('br'), _c('br'), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function ($event) {
        return _vm.addPremiumAx();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Create Premium AX ")])]), _c('div', {
    staticClass: "col-sm-3"
  })])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }